import { HingeJoint, Mesh, MeshBuilder, StandardMaterial, Vector3 ,Color3, PhysicsImpostor} from "@babylonjs/core";
import { Node } from "@babylonjs/core/node";

/**
 * This represents a script that is attached to a node in the editor.
 * Available nodes are:
 *      - Meshes
 *      - Lights
 *      - Cameas
 *      - Transform nodes
 * 
 * You can extend the desired class according to the node type.
 * Example:
 *      export default class MyMesh extends Mesh {
 *          public onUpdate(): void {
 *              this.rotation.y += 0.04;
 *          }
 *      }
 * The function "onInitialize" is called immediately after the constructor is called.
 * The functions "onStart" and "onUpdate" are called automatically.
 */
export default class Player extends Mesh {
    /**
     * Override constructor.
     * @warn do not fill.
     */
    // @ts-ignore ignoring the super call as we don't want to re-init
    protected constructor() { }

    private _target:Vector3 = null;
    private _axle:Mesh;

    /**
     * Called on the node is being initialized.
     * This function is called immediatly after the constructor has been called.
     */
    public onInitialize(): void {
        // ...
    }

    /**
     * Called on the scene starts.
     */
    public onStart(): void {
        // ...
        var scene = this.getScene();
        var impo = this.getPhysicsImpostor();
        

        //锁定 y 轴
        let yellowMat = new StandardMaterial("yellow", scene);
        yellowMat.diffuseColor = new Color3(1, 1, 0);
        let connectedAxle = MeshBuilder.CreateBox("connectedAxis", {width: 0.5, height: 6, depth: 0.5}, scene);
        connectedAxle.position.z = 6;
        connectedAxle.material = yellowMat;
        connectedAxle.physicsImpostor = new PhysicsImpostor(connectedAxle, PhysicsImpostor.BoxImpostor, {mass: 0, friction:0, restitution: 0});
        this._axle = connectedAxle;
        this._axle.position = this.position;

        let joint = new HingeJoint({  
            mainPivot: new Vector3(0, 1, 0),
            connectedPivot: new Vector3(0, 1, 0),
            mainAxis: new Vector3(0, 10, 0),
            connectedAxis: new Vector3(0, 1, 0)
        });
        
        // add the main body and joint to the connected axle 
        connectedAxle.physicsImpostor.addJoint(this.physicsImpostor, joint);
    
        joint.setMotor(1, 1000);


        let self = this;
        //如果点到物体
        scene.onPointerPick=function(){
            var pickResult = scene.pick(scene.pointerX, scene.pointerY);
    
            if (pickResult.hit) {
                if(pickResult.pickedMesh.name.substring(0,6) == "Ground"){
                    console.log("点击了：",pickResult.pickedMesh.name,pickResult.pickedPoint);
                    self._target = pickResult.pickedPoint;
                }
                // var diffX = pickResult.pickedPoint.x - box.position.x;
                // var diffY = pickResult.pickedPoint.z - box.position.z;
                // box.rotation.y = Math.atan2(diffX,diffY);			          
            }	
        }

    }

    /**
     * Called each frame.
     */
    public onUpdate(): void {
        // ...
        if(this._target){
            this.lookAt(this._target);
            this._axle.lookAt(this._target);
            //this.movePOV(0,0,-0.1);
            var rigi = this.getPhysicsImpostor();
            //rigi.setLinearVelocity((new Vector3(3,3,3)).multiply(this.forward));
            this._axle.locallyTranslate(Vector3.Forward().multiplyByFloats(0.1,0.1,0.1));
            this.locallyTranslate(Vector3.Forward().multiplyByFloats(0.1,0.1,0.1));
            console.log("移动");
            if(Vector3.Distance(this._target,this.position)<0.1){
                this._target = null;
            }
        }
    }

    /**
     * Called on the object has been disposed.
     * Object can be disposed manually or when the editor stops running the scene.
     */
    public onStop(): void {
        // ...
    }

    /**
     * Called on a message has been received and sent from a graph.
     * @param message defines the name of the message sent from the graph.
     * @param data defines the data sent in the message.
     * @param sender defines the reference to the graph class that sent the message.
     */
    public onMessage(name: string, data: any, sender: any): void {
        switch (name) {
            case "myMessage":
                // Do something...
                break;
        }
    }
}
